'use client';
import { lazy, type ComponentProps } from 'react';
export type * from "/tmp/build-510/overrides/components/product/detail/product-header.tsx";
const Deferred0 = lazy(() => import("@eliadmin/page-island-original/57097ebc0f59").then(m => ({ default: m.ProductHeader })));
const Island0 = ((props: NonNullable<ComponentProps<typeof import("/tmp/build-510/overrides/components/product/detail/product-header.tsx").ProductHeader>>) => <Deferred0 {...props} />) as typeof import("/tmp/build-510/overrides/components/product/detail/product-header.tsx").ProductHeader;
export { Island0 as ProductHeader };
